"use client";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { useTranslations } from "next-intl";
import Image from "next/image";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const ProfileDropDown = ({
  id,
  width,
  text,
  name,
  func,
  user,
  logout,
  ...rest
}) => {
  const t = useTranslations();
  return (
    <Menu as="div" className="relative mt-1">
      <div>
        <Menu.Button className="relative flex rounded-full text-sm focus:outline-none">
          <span className="absolute -inset-1.5" />
          <span className="sr-only">Open user menu</span>
          <span className="rounded-full w-9 h-9 relative overflow-hidden border">
            <Image
              src={
                user?.image
                  ? `https://api.websiteca.com/storage/${user?.image}`
                  : "https://api.websiteca.com/storage/avatar/user.png"
              }
              fill
              alt="avatar"
              objectFit="cover"
            />
          </span>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute lg:right-24 right-0 z-10 mt-3 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={func}
                className={classNames(
                  active ? "bg-gray-100" : "",
                  "block px-4 py-2 text-sm text-gray-700 w-full text-left"
                )}
              >
                {text}
              </button>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={logout}
                className={classNames(
                  active ? "bg-gray-100" : "",
                  "block px-4 py-2 text-sm text-gray-700 w-full text-left"
                )}
              >
                {t("signOut")}
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
